import React from "react";

const Button = ({
  type = "button",
  onClick,
  disabled,
  children,
  primary = true,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`w-full h-6 md:h-8 lg:h-10 xl:h-12 2xl:h-16 py-1 rounded-lg transition duration-300 text-sm md:text-base lg:text-lg xl:text-xl
        ${disabled ? "opacity-50 " : ""}
        ${
          primary
            ? "bg-indigo-700 text-[#f3f4f8] hover:shadow-[2px_2px_4px_0px_rgba(0,0,0,0.24)]"
            : "bg-[#f3f4f8]/25 !text-[#b3b5bd]"
        }`}
    >
      {children}
    </button>
  );
};

export default Button;
